<template>
  <v-app>
    <div
      v-if="term"
      class="ma-5"
    >
      <b>{{ $t("利用規約") }}</b><br>
      <p v-html="term.translated[$i18n.locale]" />
      <b>{{ $t("プライバシーポリシー") }}</b><br>
      <p v-html="privacy.translated[$i18n.locale]" />
    </div>
  </v-app>
</template>

<script>
import { Firebase } from "../config/firebase";
export default {
  name: "Rule",
  components: {},
  data() {
    return {
      loading: true,
      showPassword: false,
      alert: false,
      checkbox: false,
      login_view: false,
      password: "",
      name: "",
      phone: "",
      user: {},
      error_message: "",
      term: {},
      privacy: {},
      common: null,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  created: function () {
    this.commonFetchById();
  },
  methods: {
    commonFetchById: async function () {
      const privacyRef = await Firebase.firestore()
        .collection("translations")
        .doc("Privacy");
      privacyRef.get().then((doc) => {
        if (doc.exists) {
          this.privacy = doc.data();
        } else {
          // doc.data() will be undefined in this case
          console.log("No privacy document!");
        }
        this.error = true;
      });
      const termRef = await Firebase.firestore()
        .collection("translations")
        .doc("Term");
      termRef.get().then((doc) => {
        if (doc.exists) {
          this.term = doc.data();
        } else {
          // doc.data() will be undefined in this case
          console.log("No term document!");
        }
        this.error = true;
      });

      this.loading = false;
    },
  },
};
</script>
